export default  {
    component: 'tracker_param',
    name: 'tracker_param',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Role',
            param: 'role',
            type: 'text',
            description: `We need to add 3 types of roles:
            - **user** 
            - **admin** 
            - **super-admin**`
          },
          {
            name: 'Module',
            param: 'module',
            type: 'text',
            description: `Their are 2 options for module:
            - **analytics**
            - **other-sensor**
            We need to add module for each roles`
          },
          {
            name: 'Parameters',
            param: 'parameters',
            type: 'text',
            description: `Option for parameters are displayed as follows::
            - **other-sensor** [Parameter Options : soiling_ratio1, soiling_ratio2, transmit_loss1, transmit_loss2]
            - **analytics** [Parameter Options :  soiling_ratio1, soiling_ratio2, transmit_loss1, transmit_loss2]`
          }
    ]
  }
